import { checkCountryAccess } from "@/functions/checkCountryAccess";

// Single shared geo lookup for the whole app (RegionContext + GeoGate both
// need it on first visit). One backend call instead of two parallel ones.
let geoPromise = null;

export function getGeoInfo() {
  if (!geoPromise) {
    geoPromise = checkCountryAccess()
      .then((res) => res?.data || res || {})
      .catch(() => ({}));
  }
  return geoPromise;
}
